import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import styles from "./Dropdown.module.scss"
import { useDropdownOptionAttributesContext } from "./DropdownOptionAttributesContext"

/*
 * this element renders the current selection of the DropdownSelect
 */
export type Props = ComponentPropsWithoutRef<"div">

export const DropdownCurrentSelection = forwardRef<HTMLDivElement, Props>(
  function DropdownCurrentSelection(props: Props, propRef: Ref<HTMLDivElement>) {
    const { currentSelectionOptionAttributes } = useDropdownOptionAttributesContext()

    const className = classNames(
      props.className,
      styles.dropdownCurrentSelection,
      {
        [styles.currentSelectionDisabled]: currentSelectionOptionAttributes?.disabled,
      },
    )

    return (
      <div
        {...props}
        ref={propRef}
        className={className}
      >
        {currentSelectionOptionAttributes?.children ?? props.children}
      </div>
    )
  },
)
